module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "pt1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "PN"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_pt1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "PT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_pt1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("GHOSTS OF DAYS GONE BY")])])]), _vm._v(" "), _c('p', {
    staticClass: "EP-V"
  }, [_vm._v("Thou shalt be killed if thee can’t find")]), _vm._v(" "), _c('p', {
    staticClass: "EP-V"
  }, [_vm._v("the demon lurking in thou mind.")]), _vm._v(" "), _c('p', {
    staticClass: "EP-V"
  }, [_vm._v("So off I ventured, to quench my thirst")]), _vm._v(" "), _c('p', {
    staticClass: "EP-V"
  }, [_vm._v("of corpses piled with hearts-a-burst.")]), _vm._v(" "), _c('p', {
    staticClass: "EP-V"
  }, [_vm._v("And on that quest what did I see?")]), _vm._v(" "), _c('p', {
    staticClass: "EP-V"
  }, [_vm._v("The Wicked Path of Destiny.")]), _vm._v(" "), _c('div', {
    staticClass: "SPACE"
  }, [_c('p', {
    staticClass: "EPC"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("—Joseph Clifford")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ab456b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part1.vue
// module id = 78
// module chunks = 0